import { TOP_OFFSET } from '../../constants'

const rotateTable = {
    Up: '0deg',
    Left: '270deg',
    Down: '180deg',
    Right: '90deg',
}

export default function Entrances({ entrances, scaleFactor, offsetX = 0, offsetY = 0 }) {
    return (
        <>
            {entrances?.map((entrance, index) => {
                const entranceX = entrance?.x1
                const entranceY = entrance?.y1

                const width = entrance.x2 - entrance?.x1
                const height = entrance.y2 - entrance?.y1

                const rotation = rotateTable[entrance?.direction]

                return (
                    <div
                        key={index}
                        style={{
                            transform: `rotate(${rotation})`,
                            position: 'absolute',
                            top: `${entranceY * scaleFactor + TOP_OFFSET + offsetY}px`,
                            left: `${entranceX * scaleFactor + offsetX}px`,
                            width: width * scaleFactor,
                            height: height * scaleFactor,
                        }}
                    >
                        <img style={{ width: '100%', height: '100%' }} src="/images/icons/arrows.svg" alt="" />
                    </div>
                )
            })}
        </>
    )
}
